import { Component, inject } from '@angular/core';
import { Paging } from '../../../core/types/helper.model';
import { AssessmentHistoryService } from '../appointment-services/assessment-history.service';
import { AuthService } from '../../../core/auth/services/auth.service';
import { PreAssessment } from '../appointment-const/appointmentHistory-model';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { combineLatest } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Button, ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-assessment-history-list',
  imports: [InfiniteScrollDirective, CommonModule, ButtonModule],
  templateUrl: './assessment-history-list.component.html',
  styleUrl: './assessment-history-list.component.css',
})
export class AssessmentHistoryListComponent {
  assessmentHistoryList: PreAssessment[] = [];
  patientID!: string;

  assessmentDetails: any = {};

  isLoading = false;
  hasMoreData = true;

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
    orderby: 'created_date desc',
  };

  private assessmentHistoryService = inject(AssessmentHistoryService);
  authService = inject(AuthService);
  router = inject(Router);

  constructor() {}

  ngOnInit(): void {
    this.authService.getUserProfile().subscribe((res) => {
      if (res && res.PatientId) {
        this.patientID = res.PatientId;
        this.getAssessmentHistory(this.patientID);
        this.assessmentDetails.patientID = this.patientID; // Set patient ID in assessment details for child components
      }
    });
  }

  getAssessmentHistory(patientId: string) {
    if (this.isLoading || !this.hasMoreData) return;
    this.isLoading = true;

    this.assessmentHistoryService.getAssessmentHistory(patientId, this.paging).subscribe({
      next: (res) => {
        if (res.pre_assessment.length === 0) {
          this.hasMoreData = false;
        }

        this.assessmentHistoryList = [...this.assessmentHistoryList, ...res.pre_assessment];

        if (this.paging.pageNumber !== undefined) {
          this.paging.pageNumber++;
        }

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching assessment history:', err);
        this.isLoading = false;
        this.hasMoreData = false;
      },
    });
  }

  loadMore() {
    if (this.isLoading || !this.hasMoreData) return;

    console.log('Loading next page:', this.paging.pageNumber);

    this.getAssessmentHistory(this.patientID);
  }

  goToDetails(item: PreAssessment) {
    console.log('Go to details for:', item.id);
    // navigate to details page or open modal
    this.assessmentDetails.assessmentID = item.id;
    this.assessmentDetails.isFromAppointment = false;
    // Set the selected assessment ID in assessment details

    this.router.navigateByUrl('preassessment-details', {
      state: { assessmentDetails: this.assessmentDetails },
    });
  }
}
